import styled from 'styled-components';

export const ReviewHeading = styled.h2`
  display: flex;
  justify-content: space-between;
  margin: 0;
  margin-bottom: 15px;
  width: 100%;
  padding: 0;

  font-size: 20px;
  line-height: 1;

  span {
    color: ${({ theme }) => theme.blue};
  }
`;

export const HotelInfoContainer = styled.div`
  display: flex;
  margin-bottom: 25px;
  width: 100%;
  justify-content: flex-start;

  div {
    p {
      text-align: start;
    }
  }
`;

export const HotelPhoto = styled.div`
  width: 85px;
  height: 75px;
  margin-right: 15px;

  border-radius: 6px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;

    object-fit: cover;
  }
`;

export const ProductName = styled.p`
  margin: 0;
  padding: 0;

  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.blue};
`;

export const HotelDescr = styled.p`
  margin: 0;
  padding: 0;

  font-weight: 700;
  font-size: 10px;
  line-height: 14px;
`;

export const HotelDate = styled.p`
  font-size: 10px;
  line-height: 1;
`;

export const StepContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  width: 100%;

  text-align: center;
`;

export const StepHeading = styled.h3`
  margin: 0;
  margin-bottom: 25px;
  padding: 0;

  font-size: 17px;
  line-height: 1;
`;

export const StepSubheading = styled.p`
  margin: 0;
  margin-top: -10px;
  margin-bottom: 75px;
  padding: 0;

  font-size: 12px;
  line-height: 1;
`;

export const TextareaHeading = styled.p`
  margin: 0;
  margin-top: 30px;
  margin-bottom: 10px;
  padding: 0;

  font-size: 12px;
  line-height: 1;
`;

export const TextareaBox = styled.textarea`
  width: 100%;
  min-height: 55px;
  max-height: 20vh;
  margin: 0;
  margin-bottom: 15px;
  padding: 10px;

  font-size: 16px;
  line-height: 18px;

  border: 1px solid #ebebeb;
  border-radius: 6px;
  outline: none;

  resize: vertical;

  transition: border-color 0.3s;

  &:hover,
  &:focus {
    border-color: ${({ theme }) => theme.blue};
  }
`;

export const ReviewStars = styled.div`
  svg {
    transform: none !important;

    .star {
      stroke-width: 3px !important;
      stroke: #1eb6ff !important;
    }
  }
`;

export const AmenitiesList = styled.ul`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-between;

  max-width: 230px;
  width: 100%;
  height: 100px;
  margin: 0 auto;
  margin-bottom: 45px;

  li {
    display: flex;
    justify-content: center;
  }
`;

export const TwoOptionList = styled.ul`
  display: flex;
  justify-content: space-between;

  max-width: 230px;
  width: 100%;
  margin: 0 auto;

  & + button {
    margin-top: 30px;
  }
`;

export const TwoOption = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 105px;
  height: 45px;
  padding: 0 8px;

  font-weight: 700;
  font-size: 14px;
  line-height: 1;

  border: 2px solid ${({ isActive, theme }) => isActive ? theme.blue : '#ececec' };
  border-radius: 50px;
  outline: none;

  transition: border-color 0.3s;

  &:hover {
    border-color: ${({ theme }) => theme.blue};
  }
`;

export const Amenity = styled.button`
  display: flex;
  align-items: center;
  width: 105px;
  height: 45px;
  padding: 0 8px;

  font-weight: 700;
  font-size: 12px;
  line-height: 1;

  border: 2px solid ${({ isActive, theme }) => isActive ? theme.blue : '#ececec' };
  border-radius: 50px;
  outline: none;

  transition: border-color 0.3s;

  &:hover {
    border-color: ${({ theme }) => theme.blue};
  }

  svg {
    flex-shrink: 0;
    margin-right: 15px;
    pointer-events: none;
  }
`;

export const ReviewRangeContainer = styled.div`
  margin-top: 30px;
  padding: 25px 0;

  .input-range__slider {
    appearance: none;
    border-radius: 100%;
    cursor: pointer;
    display: block;
    width: 20px;
    height: 20px;
    margin-left: -10px;
    margin-top: -10px;
    outline: none;
    position: absolute;
    top: 50%;
    background: linear-gradient(135deg, #2DB9FE 0%, #4EDBFC 100%);
    box-shadow: 0 8px 20px rgba(30, 182, 255, 0.24);
    transition: transform 0.3s ease-out, box-shadow 0.3s ease-out;
  }

  .input-range__slider:active {
    transform: scale(1.3);
  }

  .input-range__slider:focus {
    box-shadow: 0 0 0 5px rgba(63, 81, 181, 0.2);
  }

  .input-range--disabled .input-range__slider {
    background: #cccccc;
    border: 1px solid #cccccc;
    box-shadow: none;
    transform: none;
  }

  .input-range__label {
    font-weight: 400;
    font-size: 10px;
    line-height: 1;
    color: ${({ theme }) => theme.black};
    transform: translateZ(0);
    white-space: nowrap;
  }

  .input-range__label--min,
  .input-range__label--max {
    bottom: -1.4rem;
    position: absolute;
  }

  .input-range__label--min {
    left: 0;
  }

  .input-range__label--max {
    right: 0;
  }

  .input-range__label--value {
    position: absolute;
    font-weight: 700;
    font-size: 12px;
    top: -1.8rem;
  }

  .input-range__label-container {
    left: -50%;
    position: relative;
  }

  .input-range__label--max .input-range__label-container {
    left: 50%;
  }

  .input-range__track {
    background: #d8d8d8;
    border-radius: 4px;
    cursor: pointer;
    display: block;
    height: 2px;
    position: relative;
  }

  .input-range--disabled .input-range__track {
    background: #eeeeee;
  }

  .input-range__track--background {
    left: 0;
    margin-top: -0.15rem;
    position: absolute;
    right: 0;
    top: 50%;
  }

  .input-range__track--active {
    background: #31bdfe;
  }

  .input-range {
    height: 12px;
    position: relative;
    width: 100%;
  }
`;

export const Thanks = styled.p`
  margin: 0;
  margin-bottom: 55px;
  padding: 0;

  font-size: 16px;
  line-height: 20px;
`;
